import { getConsentType } from "./cookieConsent"

interface CookieCategory {
  necessary: boolean
  preferences: boolean
  statistics: boolean
  marketing: boolean
}

// Apply cookie settings based on consent type
export const applyCookieConsent = (): CookieCategory => {
  const consentType = getConsentType()

  // Default settings - only necessary cookies allowed
  const settings: CookieCategory = {
    necessary: true, // Necessary cookies always allowed
    preferences: false,
    statistics: false,
    marketing: false
  }

  // If user has consented to all cookies
  if (consentType === "all") {
    settings.preferences = true
    settings.statistics = true
    settings.marketing = true
  }

  return settings
}

// Simple function to acknowledge that cookie settings have been initialized
export const initializeCookieSettings = (): void => {
  // No specific scripts to enable/disable, just applying consent preference
  applyCookieConsent()
  // This function can be expanded in the future if additional scripts are added
}

export default applyCookieConsent
